import type { ReactNode } from 'react'

import {
  SettingsFieldDescription,
  SettingsFieldLabel,
} from '@/components/settings/settings-field-copy'
import { SettingsRowFrame } from '@/components/settings/settings-row-frame'
import { cn } from '@/lib/utils'

export type SettingsRowProps = {
  label: string
  description?: string
  htmlFor?: string
  children: ReactNode
  className?: string
  showDivider?: boolean
}

export function SettingsRow({
  label,
  description,
  htmlFor,
  children,
  className,
  showDivider = true,
}: SettingsRowProps) {
  return (
    <SettingsRowFrame
      showDivider={showDivider}
      innerClassName={cn(
        'grid min-h-16 gap-4 py-4 sm:grid-cols-[190px_1fr] sm:items-center',
        className,
      )}
    >
      <div className="min-w-0">
        <SettingsFieldLabel htmlFor={htmlFor}>{label}</SettingsFieldLabel>
        {description ? <SettingsFieldDescription>{description}</SettingsFieldDescription> : null}
      </div>
      <div className="flex min-w-0 justify-start sm:justify-end">{children}</div>
    </SettingsRowFrame>
  )
}
